<template>
  <b-container class="pt-5">
    <b-row align-h="center" align-v="center" class="bg-light rounded">
      <b-col class="p-4">
        <h2>Zarządzanie wnioskami</h2>
        <hr />
        <b-button
          @click="$router.push({ name: 'CreateClient' })"
          class="text-right"
          variant="success"
        >
          <b-icon icon="plus"></b-icon>
          Dodaj klienta
        </b-button>
        <hr />
        <b-table striped hover :items="items" :fields="fields">
          <template v-slot:cell(index)="data">{{
            data.index + 1 + "."
          }}</template>
          <template v-slot:cell(open)="row">
            <b-button @click="open_form(row.index)" class="text-right">
              <b-icon icon="arrow-bar-right"></b-icon>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from "vue";

export default {
  name: "ProxyManage",
  data() {
    return {
      items: [],
      fields: [
        {
          key: "index",
          label: "Lp."
        },
        {
          key: "pesel",
          sortable: true,
          label: "Pesel"
        },
        {
          key: "client",
          sortable: true,
          label: "Klient"
        },
        {
          key: "date",
          sortable: true,
          label: "Data utworzenia"
        },
        {
          key: "open",
          label: "Otwórz"
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(function() {
      // clear saved pesel when entering this view
      this.$store.commit("clear_client");
      Vue.Backend.list_clients(
        this.$store.state.user.id_token,
        this.list_clients_success,
        this.list_clients_failure
      );
    });
  },
  methods: {
    list_clients_success(response_data) {
      this.items = response_data;
    },
    list_clients_failure(err) {
      console.log("Error:", err);
    },
    open_form(index) {
      this.$store.commit("set_client", this.items[index]);
      this.$router.push({ name: "Bankruptcy" });
    }
  }
};
</script>

<style scoped></style>
